module.exports = __webpack_public_path__ + "static/media/LogoTextOnly.5a6b21e8.svg";